@if (bell) {
  <div
    class="notifications me-lg-4 cursor-pt"
    routerLink="/notifications"
    [attr.aria-label]="'header.notifications' | translate"
    >
    <svg
      class="icon-header"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      >
      <g clip-path="url(#clip0_1229_48577)">
        <path
          d="M13.9993 25.666C15.2827 25.666 16.3327 24.616 16.3327 23.3327H11.666C11.666 24.616 12.7043 25.666 13.9993 25.666ZM20.9993 18.666V12.8327C20.9993 9.25102 19.086 6.25268 15.7493 5.45935V4.66602C15.7493 3.69768 14.9677 2.91602 13.9993 2.91602C13.031 2.91602 12.2493 3.69768 12.2493 4.66602V5.45935C8.90099 6.25268 6.99933 9.23935 6.99933 12.8327V18.666L5.49433 20.171C4.75933 20.906 5.27266 22.166 6.31099 22.166H21.676C22.7143 22.166 23.2393 20.906 22.5043 20.171L20.9993 18.666Z"
          />
        </g>
        <defs>
          <clipPath id="clip0_1229_48577">
            <rect width="28" height="28" fill="white" />
          </clipPath>
        </defs>
      </svg>
      <svg
        width="9"
        height="9"
        viewBox="0 0 6 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="notification-bell"
        [class.inv]="!notificationData.hasUnread()"
        >
        <circle cx="3" cy="3" r="3" fill="#FF014D" />
      </svg>
      <span class="icon-label text-basic">{{ "header.notifications" | translate }}</span>
    </div>
  }
